import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function BellNotification({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><g clipPath="url(#clip0_8_47)"><g clipPath="url(#clip1_8_47)"><path vectorEffect="non-scaling-stroke" d="M9.00023 18V18.25C9.00023 19.9 10.3402 21.25 12.0002 21.25C13.6502 21.25 15.0002 19.9 15.0002 18.25V18M11 3.54929C8.14826 4.01559 5.98023 6.48394 5.98023 9.47003V13.72L4.28023 15.43C4.09023 15.62 3.99023 15.87 3.99023 16.14V16.98C3.99023 17.53 4.43023 17.98 4.99023 17.98H18.9902C19.5402 17.98 19.9902 17.53 19.9902 16.98V16.15C19.9902 15.89 19.8802 15.63 19.7002 15.45L18.0002 13.75L17.9874 11" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></g><circle cx={18} cy={4} r={4} fill="#E86164" /></g><defs><clipPath id="clip0_8_47"><rect width={24} height={24} fill="currentColor" /></clipPath><clipPath id="clip1_8_47"><rect width={24} height={24} fill="currentColor" /></clipPath></defs></Svg>;
}
export default BellNotification;